var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-input',{attrs:{"module":_vm.Info.Modal.VendorItem.Module,"moduleType":_vm.Info.Modal.VendorItem.ModuleType,"width":950},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('List',{attrs:{"userVendorItemList":_vm.userVendorItemList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }